import {Breadcrumb} from 'antd';
import {faCaretRight} from '@fortawesome/pro-solid-svg-icons';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {observer} from 'mobx-react-lite';

const HierarchyTreeBreadcrumb = ({path}) => (
  <Breadcrumb style={{marginTop: 4}} separator={<FontAwesomeIcon icon={faCaretRight}/>}>
    {path.map((part) => <Breadcrumb.Item key={part}>{part}</Breadcrumb.Item>)}
  </Breadcrumb>
);

export default observer(HierarchyTreeBreadcrumb);
export const renderBreadcrumb = (path) => <HierarchyTreeBreadcrumb path={path}/>;
